import { initWebauthnAuthenticate } from './webauthn';

export const mount2faAuthentication = () => {
  initWebauthnAuthenticate();
};
